import { MantineThemeOverride } from '@mantine/core';

export type TimelineTheme = NonNullable<MantineThemeOverride['components']>['Timeline'];

export const Timeline: TimelineTheme = {
  // todo: define
};
